import { CarTrialExtensionBlock } from './CarTrialExtensionBlock'

export const carDealershipBlocks = {
  carTrialExtension: CarTrialExtensionBlock,
}
